module.exports = __webpack_public_path__ + "img/pk_center_user_bg.58de38ef.png";